export default "__VITE_ASSET__CQR36VcX__"